import { useState } from 'react'
import { Link } from 'react-router-dom'
import { ComingSoonBanner } from '../components/Alert'
import { EmptyState } from '../components/States'

const TRIGGERS: Array<[string, string]> = [
  ['Email in', 'Send a file to a private address'],
  ['FTP / SFTP', 'We poll a folder you control'],
  ['Local folder', 'Desktop agent watches a folder'],
  ['Zapier', 'Trigger from 6,000+ apps'],
  ['Schedule', 'Time-based export'],
]

export function AutomationPage() {
  const [trigger, setTrigger] = useState(TRIGGERS[0][0])

  return (
    <div className="wrap">
      <div className="phead">
        <div>
          <div className="crumb">
            <Link to="/app">Home</Link> / Automation
          </div>
          <h2>Automation</h2>
          <p className="fs13 muted" style={{ margin: '6px 0 0' }}>
            Run imports and exports without opening the app. Files arrive, jobs run, you get an email
            if something breaks.
          </p>
        </div>
        <span className="spacer" />
        <span className="tagp t-p1">P1</span>
        <button className="btn btn-p" type="button" disabled>
          + New automation
        </button>
      </div>

      <ComingSoonBanner feature="Automation" />

      <div className="srcs" style={{ marginBottom: 18 }}>
        {TRIGGERS.map(([name, hint]) => (
          <div
            className={trigger === name ? 'src on' : 'src'}
            key={name}
            onClick={() => setTrigger(name)}
          >
            <b>{name}</b>
            <span className="fs12 faint" style={{ display: 'block', marginTop: 4 }}>
              {hint}
            </span>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-h">
          <h3>Active automations</h3>
          <span className="spacer" />
          <span className="fs12 faint">0 configured</span>
        </div>
        <EmptyState
          icon="⚙"
          title="No automations yet"
          body="Unattended runs need a scheduler endpoint that is not in the current API. Each automation will show its trigger, action, company, last run and health here."
        />
      </div>
    </div>
  )
}
